import React, { createRef, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { getStoreFormData, setFormDataMainFunc } from '../utils';
import { cartForm, getFormStyles, getFormUserData } from '../initData';
import { getData } from '../../../../../../../common/utils/router';
import UserContext, { StoreContext, UserProfileContext } from '../../../../../../../common/utils/getContext';
// import ModalStore from '../components/ModalStore/ModalStore';
import CartSwitcher from '../components/CartSwitcher/CartSwitcher';
import Loader from '../../../../../../../widgets/plug/Loader/Loader';
// import T from '../../../../../../../common/components/T';
import css from './StoreCart.module.scss';
import classnames from 'classnames';
// import { svgSprite } from '../../../../../../../hybrid/wrappers';
import CartCalculate from '../components/CartCalculate/CartCalculate';
// import { useRouter } from 'next/router';
import FinishManualInMoney from './components/FinishManualInMoney/FinishManualInMoney';
import { zendoStorage } from '../../../../../../../hybrid/wrappers';
import { getUserCurrencyAccounts } from '../../../../../../../common/utils/utils';

const StoreCart = ({ setActiveStep, activeStep, partner, userData, initValue }) => {
    const { userToken, lang, localization } = useContext(UserContext);
    const { profileData, loaded } = useContext(UserProfileContext) || {};

    const { cartData, isLoading, isLoading: cartLoading } = useContext(StoreContext) || {};
    const products = cartData.items;
    // const router = useRouter();
    const [delivery, setDelivery] = useState(null);

    const isOfficeRegister = typeof window !== undefined ? zendoStorage.get('isOfficeRegister') : false;

    const [loading, setLoading] = useState(false);
    const [isComboPayment, setIsComboPayment] = useState(false);
    const [newUser, setNewUser] = useState(profileData ? 2 : 1);
    // const [showModal, setShowModal] = useState(false);
    // const setAnswerAfterCheckout = () => {};
    const [answerAfterCheckout, setAnswerAfterCheckout] = useState(null);
    const [formsData, setFormsData] = useState(false);
    const [paymentFormData, setPaymentFormData] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [responseComisson, setResponseComisson] = useState(null);
    const [convertedData, setConvertedData] = useState([]);

    const [selectedPaymentSystems, setSelectedPaymentSystems] = useState([]);
    const cartMainWrapper = useRef();
    const setSelectedPaymentSystems_ = useCallback((data) => {
        setSelectedPaymentSystems(data);
    }, []);

    useEffect(() => {
        setNewUser(profileData ? 2 : 1);
    }, [profileData]);

    useEffect(() => {
        if (!profileData) {
            setNewUser(1);
        }
    }, [profileData]);

    useEffect(() => {
        getFormUserData(userData, setFormsData, isOfficeRegister);
    }, [
        userData?.last_name,
        userData?.first_name,
        userData?.contacts?.phone,
        userData?.contacts?.email,
        userData,
        profileData,
        isOfficeRegister
    ]);
    const arrRef = cartForm.map(() => createRef());
    const myRef = useRef(arrRef);
    const submitPaymentFormDataRef = useRef(null);

    const [storeData, setStoreData] = useState({
        ...(profileData || {}),
        statusUser: profileData ? '1' : '0',
        newuser_agree: '1',
        delivery_type: '',
        do_not_call_back: '0',
        police_agree: '1',
        delivery_country_id: userData?.country_id,
        ...(newUser === 1 ? { sponsor_name: null } : {})
    });
    useEffect(() => {
        if (userData) {
            setStoreData((pre) => ({
                ...pre,
                ...(isOfficeRegister
                    ? {
                          recipient_second_name: userData?.last_name,
                          recipient_name: userData?.first_name,
                          recipient_email: userData?.email,
                          recipient_phone: userData?.recipient_phone,
                          recipient_type: 'third_person',
                          delivery_country_id: userData?.country_id
                      }
                    : {
                          second_name: userData?.first_name,
                          name: userData?.last_name,
                          email: userData?.email,
                          phone: userData?.phone,
                          recipient_type: 'me',
                          delivery_country_id: userData?.country_id
                      })
            }));
        }
    }, [userData, isOfficeRegister]);

    // useEffect(() => {
    // const user_geo_data = ['country', 'region', 'city', 'address'];
    // const user_geo_data_cart = ['delivery_country_id', 'delivery_state_id', 'delivery_city_id', 'address'];
    // if (isOfficeRegister && partner) {
    //     setStoreData((s) => ({
    //         ...s,
    //         ...user_geo_data.reduce((acc, key, idx) => {
    //             if (partner[key]) {
    //                 if (key == 'country') {
    //                     acc[user_geo_data_cart[idx]] = partner[key];
    //                     acc['delivery_state_id'] = null;
    //                     acc['delivery_city_id'] = null;
    //                 }
    //             }
    //             return acc;
    //         }, {})
    //     }));
    // } else {
    //     setStoreData((s) => ({
    //         ...s,
    //         ...user_geo_data.reduce((acc, key, idx) => {
    //             if (profileData[key]) {
    //                 acc[user_geo_data_cart[idx]] = profileData[key];
    //             }
    //             return acc;
    //         }, {})
    //     }));
    // }
    // }, [isOfficeRegister, profileData, partner]);

    const setFormDataMain = useCallback(
        (key, val) => setFormDataMainFunc(key, val, setStoreData, setSelectedPaymentSystems),
        [setStoreData]
    );

    useEffect(() => {
        if (!isLoading && !cartLoading) {
            if (+activeStep !== 2) return;
            (async () => {
                const country_id = userData?.country_id?.id;
                const paymentData = await getData(
                    `/api/v1/payment-systems?filter[payment_enabled]=true${
                        country_id ? `&filter[country_id]=${country_id}` : ''
                    }`,
                    userToken,
                    lang
                );
                const financeData =
                    userToken && cartData?.id
                        ? await getUserCurrencyAccounts(
                              country_id ? `?filter[country_id]=${country_id}` : '',
                              localization?.currency,
                              userToken,
                              lang
                          )
                        : null;
                const paymentDataArray = Array.isArray(paymentData?.data) ? paymentData?.data : [];
                const sorted = [
                    ...paymentDataArray?.filter((ps) => !ps.accept_cryptocurrency_payments),
                    ...paymentDataArray?.filter((ps) => !!ps.accept_cryptocurrency_payments)
                ];
                setStoreData((pre) => ({
                    ...pre,
                    paymentData: sorted || [],
                    financeData: financeData?.data || []
                }));
                setLoading(true);
            })();
            const answerAfterCheckout = localStorage.getItem('answerAfterCheckout');
            const parseCheckout = JSON.parse(answerAfterCheckout);
            if (parseCheckout?.cartData && cartData?.id) {
                if (parseCheckout?.cartData !== cartData?.id && !!cartData?.items?.length) {
                    localStorage.removeItem('answerAfterCheckout');
                } else if (!!answerAfterCheckout) {
                    setAnswerAfterCheckout({
                        ...JSON.parse(answerAfterCheckout)?.data,
                        data: JSON.parse(answerAfterCheckout)?.expireTime
                    });
                    setSelectedPayment(JSON.parse(answerAfterCheckout)?.selectedPayment);
                    setResponseComisson(JSON.parse(answerAfterCheckout)?.responseComisson);
                }
            }
        }
    }, [cartData, isLoading, lang, localization, userToken, userData, activeStep, cartLoading]);

    useEffect(() => {
        (async () => {
            if (storeData?.financeData && storeData?.financeData.data && storeData?.finance_account_id) {
                let reset = storeData?.financeData.data.filter((el) => el.id === storeData?.finance_account_id);
                if (reset && reset.length <= 0) {
                    setFormDataMain('payment_type', null, setStoreData, setNewUser);
                    setFormDataMain('finance_account_id', null, setStoreData, setNewUser);
                }
            }
        })();
    }, [setFormDataMain, storeData]);
    useEffect(() => {
        if (submitPaymentFormDataRef?.current) {
            submitPaymentFormDataRef?.current?.submit();
        }
    }, [submitPaymentFormDataRef, paymentFormData]);
    const storeFormData = useMemo(() => getStoreFormData(formsData), [formsData]);
    const formStyles = useMemo(() => getFormStyles(css), []);
    const [formDataError, setFormDataError] = useState({});

    useEffect(() => {
        return () => {
            zendoStorage.remove('cart_id');
        };
    }, []);

    // const deleledProduct = useCallback(async () => {
    //     await deleteProducts(setAlertData, cartData, setCartData, userToken, lang, setFormDataError, router, localization);
    // }, [cartData, lang, localization, router, setAlertData, setCartData, setFormDataError, userToken]);

    if (activeStep !== 2) return null;
    if (!formsData && !storeData) return <Loader />;
    if ((!formsData && !profileData) || !loaded || !loading) return <Loader />;
    return (
        <div className={classnames(css.wrapper, activeStep !== 2 && css.dn)}>
            <div className={css.wrapperBG}>
                {answerAfterCheckout ? (
                    <FinishManualInMoney
                        selectedPay={storeData.paymentData.find((p) => p.id === storeData.payment_system_id) || selectedPayment}
                        data={answerAfterCheckout}
                        responseComisson={
                            responseComisson
                                ? {
                                      ...responseComisson,
                                      ...(responseComisson.payment_amount_formatted
                                          ? { account_total_amount_formatted: responseComisson.payment_amount_formatted }
                                          : {})
                                  }
                                : {}
                        }
                    />
                ) : (
                    <div className={classnames(css.storeWrapper, css.storeWrapperTitled)}>
                        <div>
                            <div className={css.cartMainWrapper} ref={cartMainWrapper}>
                                <div className={css.groupFormWrapper}>
                                    {cartForm.map((elemForm, idx) => {
                                        return (
                                            <div
                                                ref={myRef.current[idx]}
                                                className={classnames(css.formWrapper, {
                                                    [css.formWrapperOrder]: elemForm.group === 'order'
                                                })}
                                                key={`cartForm${idx}`}
                                            >
                                                {/* {idx === 0 ? (
                                                    <div className={css.cartTopTitleWrapper}>
                                                        <p className={css.storeTitleMain}>
                                                            <T
                                                                textName='storeOrderCreate-2'
                                                                defaultStr='Оформление заказа'
                                                                page='/store'
                                                            />
                                                        </p>
                                                        <p className={css.storeCartDeleteProducts} onClick={deleledProduct}>
                                                            <T textName='delete-all' defaultStr='Удалить все' page='/store' />
                                                        </p>
                                                    </div>
                                                ) : null} */}
                                                <CartSwitcher
                                                    cartData={cartData}
                                                    isComboPayment={isComboPayment}
                                                    setIsComboPayment={setIsComboPayment}
                                                    selectedPaymentSystems={selectedPaymentSystems}
                                                    setSelectedPaymentSystems={setSelectedPaymentSystems_}
                                                    convertedData={convertedData}
                                                    setConvertedData={setConvertedData}
                                                    elemForm={elemForm}
                                                    storeData={storeData}
                                                    newUser={newUser}
                                                    setNewUser={setNewUser}
                                                    setFormDataMain={setFormDataMain}
                                                    formDataError={formDataError}
                                                    setFormDataError={setFormDataError}
                                                    formStyles={formStyles}
                                                    storeFormData={storeFormData}
                                                    products={products}
                                                    setStoreData={setStoreData}
                                                    userData={profileData}
                                                    setSelectedPayment={setSelectedPayment}
                                                    selectedPayment={selectedPayment}
                                                    setDelivery={setDelivery}
                                                    delivery={delivery}
                                                    partner={partner}
                                                    initValue={initValue}
                                                />
                                                <div
                                                    className={classnames(css.formLine, {
                                                        [css.dn]: !cartForm[idx + 1]
                                                    })}
                                                ></div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <CartCalculate
                                    {...{
                                        setAnswerAfterCheckout,
                                        storeData,
                                        selectedPayment,
                                        setResponseComisson,
                                        setFormDataError,
                                        newUser,
                                        cartForm,
                                        setPaymentFormData,
                                        responseComisson,
                                        myRef,
                                        isComboPayment,
                                        selectedPaymentSystems,
                                        convertedData,
                                        setConvertedData,
                                        container: cartMainWrapper,
                                        delivery,
                                        setActiveStep: setActiveStep,
                                        partner,
                                        isOfficeRegister: isOfficeRegister,
                                        initValue,
                                        profileData
                                    }}
                                />
                            </div>
                            {paymentFormData ? (
                                <div style={{ display: 'none' }}>
                                    <form
                                        ref={submitPaymentFormDataRef}
                                        action={paymentFormData?.action}
                                        method={paymentFormData?.method_form || 'POST'}
                                    >
                                        {Object.keys(paymentFormData.data).map((field) => (
                                            <input
                                                key={`paymentFormData${field}`}
                                                type='hidden'
                                                name={field}
                                                value={paymentFormData.data[field]}
                                            />
                                        ))}
                                    </form>
                                </div>
                            ) : null}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
export default StoreCart;
